import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { modal } from 'react-redux-modal';
import {
  FeedbackModal
} from '../../../components';

import './styles.scss';
import { modalViewGA } from '../../../utils/googleAnalytics';
import TrackedButton from '../../Buttons/TrackedButton';

const contextTypes = {
  router: PropTypes.object,
};

class SocialModal extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.onFeedback = this.onFeedback.bind(this);
  }

  closeModal(e) {
    e.preventDefault();
    this.props.removeModal();
  }

  componentDidMount() {
    modalViewGA('socialModal');
  }

  onFeedback (e) {
    e.preventDefault();
    modal.clear();
    modal.add(FeedbackModal, {size:'medium', hideTitleBar: true});
  }

  render() {
    const { currentItem } = this.props;

    return (
      <div className="modals-popup social-modal u-font-foundation-roman">
        <div className="modal-header d-flex align-items-center">
          <div className="col">explore.org - never stop learning</div>
          <div className="text-right">
            <a className="closer" href="#" onClick={this.closeModal}></a>
          </div>
        </div>
        <div className="info">
          <div className="mb-20">
            <div className="">
              <p>Welcome to Explore.org’s global family! Our curated social media communities
              celebrate selflessness, connect humanity to nature and inspire lifelong learning.
              They are the perfect antidote to stress. Please follow one or all of them.</p>

              <div className="collection-block">
                <span className="u-font-foundation-bold">Facebook Collection</span>
                <br/>
                <div className="link-block">
                  <Link to="https://www.facebook.com/exploreorg/" target="_blank">Explore.org</Link>
                  <TrackedButton
                    type="link"
                    to="https://www.facebook.com/exploreorg/"
                    target="_blank"
                    className="follow-btn u-font-foundation-roman float-right"
                    title="Follow"
                    action="Click on Follow for Explore Facebook"
                    gaAction="Click on Follow for Explore Facebook"
                    value={75}
                  />
                </div>
                <p>With millions of fans around the world, here is where we share
                our live cam streams, curated golden moments, fascinating fact videos, and
                educational chats. We also premiere documentary films and showcase amazing
                world class photography.</p>
                <div className="link-block">
                  <Link to="https://www.facebook.com/exploredogs/" target="_blank">Dog Bless You</Link>
                  <TrackedButton
                    type="link"
                    to="https://www.facebook.com/exploredogs/"
                    target="_blank"
                    className="follow-btn u-font-foundation-roman float-right"
                    title="Follow"
                    action="Click on Follow for Explore Dogs Facebook"
                    gaAction="Click on Follow for Explore Dogs Facebook"
                    value={75}
                  />
                </div>
                <p>We dedicate Dog Bless You to the guardian angels of the
                human spirit. This is where we celebrate the special bond between people
                and their dogs, and our community makes connections based on this unconditional
                love. Dog Bless You is also the leading provider of service dogs to soldiers in
                the United States of America.</p>
                <div className="link-block">
                  <Link to="https://www.facebook.com/explorecats/" target="_blank">Cat Bless You</Link>
                  <TrackedButton
                    type="link"
                    to="https://www.facebook.com/explorecats/"
                    target="_blank"
                    className="follow-btn u-font-foundation-roman float-right"
                    title="Follow"
                    action="Click on Follow for Explore Cats Facebook"
                    gaAction="Click on Follow for Explore Cats Facebook"
                    value={75}
                  />
                </div>
                <p>Cats bring so much joy, affection, and playful attitude into our
                lives. At Cat Bless You we celebrate rescued cats and kittens with the hopes that
                many will be adopted into loving forever homes.</p>
              </div>

              <div className="collection-block">
                <span className="u-font-foundation-bold">Instagram Collection</span>
                <br/>
                <div className="link-block">
                  <Link to="https://www.instagram.com/exploreorg/" target="_blank">Explore.org</Link>
                  <TrackedButton
                    type="link"
                    to="https://www.instagram.com/exploreorg/"
                    target="_blank"
                    className="follow-btn u-font-foundation-roman float-right"
                    title="Follow"
                    action="Click on Follow for Explore.org Instagram"
                    gaAction="Click on Follow for Explore.org Instagram"
                    value={75}
                  />
                </div>
                <p>Featuring stunning photography both from live cams fans
                like you and world-class artists. Follow us on Instagram to catch bite-sized golden moments
                from our our live cams and documentary film library.</p>
                <div className="link-block">
                  <Link to="https://www.instagram.com/exploreorgculture/" target="_blank">Exploreorg Culture</Link>
                  <TrackedButton
                    type="link"
                    to="https://www.instagram.com/exploreorgculture/"
                    target="_blank"
                    className="follow-btn u-font-foundation-roman float-right"
                    title="Follow"
                    action="Click on Follow for Explore.org Culture Instagram"
                    gaAction="Click on Follow for Explore.org Culture Instagram"
                    value={75}
                  />
                </div>
                <p>Explore.org hosts one of the world’s premiere documentary
                film and photography libraries. See selfless heroes and learn their stories. Ponder art and
                architecture. Get a dose of culture.</p>
              </div>

              <div className="collection-block">
                <span className="u-font-foundation-bold">Twitter</span>
                <br/>
                <div className="link-block">
                  <Link to="https://twitter.com/exploreorg" target="_blank">Explore.org</Link>
                  <TrackedButton
                    type="link"
                    to="https://twitter.com/exploreorg"
                    target="_blank"
                    className="follow-btn u-font-foundation-roman float-right"
                    title="Follow"
                    action="Click on Follow for Explore.org Twitter"
                    gaAction="Click on Follow for Explore.org Twitter"
                    value={75}
                  />
                </div>
                <p>Stay in the loop with real-time tweets about moments unfolding
                on our live cams, news from Explore, and special events.</p>
              </div>

              <div className="collection-block">
                <span className="u-font-foundation-bold">YouTube Collection</span>
                <br/>
                <div className="link-block">
                  <Link to="https://www.youtube.com/channel/UC-2KSeUU5SMCX6XLRD-AEvw" target="_blank">Explore Live Nature Cams</Link>
                  <TrackedButton
                    type="link"
                    to="https://www.youtube.com/channel/UC-2KSeUU5SMCX6XLRD-AEvw"
                    target="_blank"
                    className="follow-btn u-font-foundation-roman float-right"
                    title="Follow"
                    action="Click on Follow for Explore Live Nature Cams YouTube"
                    gaAction="Click on Follow for Explore Live Nature Cams YouTube"
                    value={75}
                  />
                </div>
                <p>Explore is your window into the natural world.
                This channel curates all the best moments from our vast collection of live cams to keep you
                relaxed, amazed and entertained with our amazing planet.</p>
                <div className="link-block">
                  <Link to="https://www.youtube.com/channel/UCCbwUYR84ej2zyMBhdEUcZQ" target="_blank">Explore Education</Link>
                  <TrackedButton
                    type="link"
                    to="https://www.youtube.com/channel/UCCbwUYR84ej2zyMBhdEUcZQ"
                    target="_blank"
                    className="follow-btn u-font-foundation-roman float-right"
                    title="Follow"
                    action="Click on Follow for Explore Education YouTube"
                    gaAction="Click on Follow for Explore Education YouTube"
                    value={75}
                  />
                </div>
                <p>Never stop learning with Explore Education. This channel
                is your gateway to fascinating talks with guest naturalists from our partner organizations and
                other experts from around the world.</p>
                <div className="link-block">
                  <Link to="https://www.youtube.com/user/exploreTeam" target="_blank">Explore Documentary Films</Link>
                  <TrackedButton
                    type="link"
                    to="https://www.youtube.com/user/exploreTeam"
                    target="_blank"
                    className="follow-btn u-font-foundation-roman float-right"
                    title="Follow"
                    action="Click on Follow for Explore Documentary Films YouTube"
                    gaAction="Click on Follow for Explore Documentary Films YouTube"
                    value={75}
                  />
                </div>
                <p>Part of Explore’s mission is to champion the
                selfless acts of others, these short and long-form films will inspire you.</p>
              </div>

              <div className="collection-block">
                <span className="u-font-foundation-bold">Medium</span>
                <br/>
                <div className="link-block">
                  <Link to="https://medium.com/@exploreorg" target="_blank">Explore.org</Link>
                  <TrackedButton
                    type="link"
                    to="https://medium.com/@exploreorg"
                    target="_blank"
                    className="follow-btn u-font-foundation-roman float-right"
                    title="Follow"
                    action="Click on Follow for Explore.org Medium"
                    gaAction="Click on Follow for Explore.org Medium"
                    value={75}
                  />
                </div>
                <p>Explore is moving our blog to Medium, a vibrant community
                that celebrates the written word.</p>
              </div>

            </div>
            <div className="d-flex justify-content-end">
              <button className="video-player-btn text-btn inverse-btn text-uppercase"
                onClick={(e)=>{this.onFeedback(e)}}>
                <div>feedback</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

}
const mapStateToProps = (state) => {
  return {
    currentItem: state.currentItem.data,
  };
}
SocialModal.contextTypes = contextTypes;
export default connect(mapStateToProps)(SocialModal);
